class ProductComparison extends HTMLElement {
  constructor() {
    super();
    this.products = [];
    // Checkbox that triggers the tool
    this._lastActiveCheckbox = null;
    this._isClosingBar = false;
  }

  connectedCallback() {
    this.initialiseProducts();
    this.handleArrowButtonClick();
    this.synchroniseScroll();

    // Bind a listener to all product card checkboxes
    document.querySelectorAll(".comparison-checkbox").forEach((checkbox) => {
      checkbox.addEventListener("change", this.handleCheckboxChange.bind(this));
    });

    // Toggle comparison bar
    document
      .querySelector(".comparison-toggle-button")
      .addEventListener("click", this.toggleComparison.bind(this));
    document
      .querySelector(".icon-modal-close-wrapper")
      .addEventListener("click", this.toggleComparison.bind(this));

    // Open full comparison modal
    document
      .querySelector(".compare-all")
      .addEventListener("click", this.renderComparisonModal.bind(this));

    //   Close on esc
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        const modal = document.querySelector(".product-comparison-modal");
        if (modal && modal.style.display === "block") {
          this.closeComparisonModal();
        } else {
          this.closeComparison();
        }
      }
    });

    // Add event listener for the clear button
    const clearButton = document.querySelector(".comparison-clear");
    if (clearButton) {
      clearButton.addEventListener("click", () => {
        this.clearAllProducts(this.products);
      });
    }

    const toggleButton = document.querySelector(".comparison-toggle-button");
    if (toggleButton) {
      // toggleButton.addEventListener("keydown", (e) => {
      //   // Shift+Tab from toggle button goes to last active checkbox
      //   if (e.key === "Tab" && e.shiftKey && this._lastActiveCheckbox) {
      //     e.preventDefault();
      //     this._lastActiveCheckbox.focus();
      //   }
      //   // Escape on toggle button closes the bar and returns focus to checkbox
      //   if (e.key === "Escape" && this._lastActiveCheckbox) {
      //     e.preventDefault();
      //     this.closeComparison();
      //   }
      // });
    }
  }

  // Open/Closes the comparison bottom bar
  toggleComparison() {
    const comparisonSection = document.querySelector("product-comparison");
    const isHidden = comparisonSection.hasAttribute("hidden");

    if (isHidden) {
      this.openComparison();
      this._previouslyFocusedElement = document.activeElement;
      if (window.innerWidth <= 989) {
        document.querySelector("gaia-header").style.zIndex = "0";
      }
      this.trapFocusInBar();
    } else {
      this.closeComparison();
      document.querySelector("gaia-header").style.zIndex = "1000000";
    }
  }

  // Open bottom comparison bar
  openComparison() {
    const comparisonSection = document.querySelector("product-comparison");
    comparisonSection.removeAttribute("hidden");
    this.setToggleExpanded(true);

    // Accessibility trap focus to the comparison bar. Change between mobile/desktop.
    //   const focusFirstElement =
    //     window.innerWidth <= 989
    //       ? document.querySelector(".icon-modal-close-wrapper")
    //       : document.querySelector(".comparison-toggle-button");
    //   const focusSecondElement = comparisonSection.querySelector(
    //     ".comparison-product-img-wrapper"
    //   );
    //   const focusLastElement = document.querySelector(".comparison-clear");
    //   console.log("openComparison called", {
    //     focusFirstElement,
    //     focusLastElement,
    //   });
    //   this.setFocus(focusFirstElement, focusSecondElement, focusLastElement);
  }

  // Keep the docked tab's expanded state in sync with the panel
  setToggleExpanded(isExpanded) {
    const toggleButton = document.querySelector(".comparison-toggle-button");
    if (toggleButton) {
      toggleButton.setAttribute("aria-expanded", isExpanded ? "true" : "false");
    }
  }

  // Close bottom comparison bar
  closeComparison() {
    this._isClosingBar = true;
    console.log("closeComparison: Hiding bar and removing trap");

    const comparisonSection = document.querySelector("product-comparison");
    comparisonSection.setAttribute("hidden", true);
    this.setToggleExpanded(false);

    this.removeBarFocusTrap();
    this._isClosingBar = false;

    // Focus the element that was focused before opening, if available
    setTimeout(() => {
      if (
        this._lastActiveCheckbox &&
        typeof this._lastActiveCheckbox.focus === "function" &&
        document.body.contains(this._lastActiveCheckbox) &&
        this._lastActiveCheckbox.offsetParent !== null
      ) {
        this._lastActiveCheckbox.focus();
        this._lastActiveCheckbox = null;
      } else {
        const toggleButton = document.querySelector(
          ".comparison-toggle-button"
        );
        if (toggleButton) {
          toggleButton.focus();
        }
      }
    }, 0);
  }

  // When a product card checkbox is checked/unchecked for comparison
  handleCheckboxChange(event) {
    const checkbox = event.target;
    const dataProduct = checkbox.getAttribute("data-product");
    this._lastActiveCheckbox = checkbox;

    let productData;

    // Check the product actually has the data
    try {
      productData = JSON.parse(dataProduct);
    } catch (error) {
      return;
    }

    if (checkbox.checked) {
      this.addProduct(productData);

      // Move focus to the toggle button
      const toggleButton = document.querySelector(".comparison-toggle-button");
      if (toggleButton) {
        toggleButton.focus();

        // Trap Shift+Tab to return focus to the checkbox
        const trapShiftTab = (e) => {
          if ((e.key === "Tab" && e.shiftKey) || e.key === "Tab") {
            e.preventDefault();
            checkbox.focus();
          }
        };
        toggleButton.addEventListener("keydown", trapShiftTab);

        // Remove the trap after focus leaves the toggle button
        const removeTrap = () => {
          toggleButton.removeEventListener("keydown", trapShiftTab);
          toggleButton.removeEventListener("blur", removeTrap);
        };
        toggleButton.addEventListener("blur", removeTrap);
      }
    } else {
      this.removeProduct(productData.id);
    }
  }

  // Add product to the comparison tool
  addProduct(productData) {
    // If product data is null/empty on start, ensure it stays that way (Fallback for clearing)
    if (
      !productData ||
      (Array.isArray(productData) && productData.length === 0)
    ) {
      this.products = [];
      return;
    }

    // Check if product already exists (So no double adds) by comparing unique IDs
    const productExists = this.products.some(
      (product) => product.id === productData.id
    );
    if (productExists) {
      return;
    }

    // Check if the maximum limit of 3 products is reached
    if (this.products.length >= 3) {
      alert("You can only compare up to 3 products.");
      // Uncheck the checkbox that triggered this
      const checkbox = document.querySelector(
        `.comparison-checkbox[value="${productData.id}"]`
      );
      if (checkbox) {
        // Uncheck the box, as it couldn't add
        checkbox.checked = false;
      }
      return;
    }

    // This is just so it doesn't throw up a fuss about it having no swatches and just handles the error
    if (!productData.swatches) {
      // console.log(`Product with ID ${productData.id} has no swatches.`);
    } else {
      // console.log(
      //   `Product with ID ${productData.id} has swatches:`,
      //   productData.swatches
      // );
    }

    // Add the product to the comparison list
    this.products.push(productData);
    // Run updates
    this.updateProductsStorage();
    this.renderBar();
    this.toggleComparisonOpen();
    this.removeSingleProduct();
    this.accessibilityUpdates();
    this.updateComparisonCount();
  }

  //   Remove product from the comparison tool
  removeProduct(id) {
    // Filter out the product with the given ID
    this.products = this.products.filter(
      (product) => String(product.id) !== String(id)
    );

    // Run updates
    this.updateProductsStorage();
    this.renderBar();
    this.toggleComparisonOpen();
    this.removeSingleProduct();
    this.accessibilityUpdates();
    this.updateComparisonCount();

    // Check if the modal is open and update its content
    const modal = document.querySelector(".product-comparison-modal");
    if (modal && modal.style.display === "block") {
      this.renderComparisonModal();
    }

    // If it was the last product, close the comparison tool
    if (this.products.length === 0) {
      this.closeComparisonModal();
      this.closeComparison();
    }

    // Uncheck its checkbox on any product cards on the page
    const checkbox = document.querySelector(
      `.comparison-checkbox[value="${id}"]`
    );
    if (checkbox) {
      checkbox.checked = false;
    }
  }

  // When a single product is removed (such as the x icon clicked on it), get the ID to remove
  removeSingleProduct() {
    const removeButtons = document.querySelectorAll(
      ".comparison-product-remove"
    );
    removeButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        const targetButton = event.target.closest("button");
        const productId = targetButton.getAttribute("data-product-id");
        this.removeProduct(productId);

        // Only re-trap if the bar is still open and there are products left
        const bar = document.querySelector("product-comparison:not([hidden])");
        if (bar && this.products.length > 0) {
          this.trapFocusInBar();
        } else {
          this.removeBarFocusTrap();
        }
      });
    });
  }
  // Update the local storage so the tool saves states across browsing. Metafields must be saved individually, as they can't
  // be fetched from the API later on e.g gender, season etc.
  updateProductsStorage() {
    const validatedProducts = this.products.map((product) => {
      try {
        return {
          id: String(product.id),
          title: product.title || "",
          url: product.url,
          swatches: product.swatches || null,
          gender: product.gender || "",
          season: product.season || "",
          specifications: product.specifications || {},
        };
      } catch (error) {
        return null;
      }
    });

    const filteredProducts = validatedProducts.filter(
      (product) => product !== null
    );
    const productsString = JSON.stringify(filteredProducts);
    localStorage.setItem("comparisonProducts", productsString);
    // console.log(
    //   "Updated products in localStorage:",
    //   localStorage.getItem("comparisonProducts")
    // );
  }

  // Load products from localStorage when landing on a new page
  getProductsFromStorage() {
    // console.log(
    //   "getProductsFromStorage called. Current products:",
    //   this.products
    // );
    const productsString = localStorage.getItem("comparisonProducts");
    if (productsString) {
      try {
        const decodedProducts = JSON.parse(productsString).map((product) => ({
          ...product,
          swatches: product.swatches || null,
        }));
        this.products = decodedProducts;
        // console.log("Loaded products from localStorage:", this.products);

        // On page load, check any stored products' checkboxes by matching the product IDs
        document
          .querySelectorAll(".comparison-checkbox")
          .forEach((checkbox) => {
            const checkboxValue = checkbox.value;

            const isProductSaved = this.products.some(
              (product) => String(product.id) === String(checkboxValue)
            );

            if (isProductSaved) {
              checkbox.checked = true;
            }
          });
      } catch (error) {
        this.products = [];
        // console.log("Errors found in localStorage. Resetting products.");
      }
    } else {
      // No stored products found in localStorage
      this.products = [];
      // console.log("No products found in localStorage. Resetting products.");
    }
    // console.log("After loading from localStorage:", this.products);
  }

  // Clear all products from localStorage and tool
  clearAllProducts(productData) {
    // console.log("Clearing ", productData);
    // Clear the products array
    productData.forEach((product) => {
      // console.log("Removing product:", product);
      this.removeProduct(product.id);
    });
    // Clear localStorage
    localStorage.removeItem("comparisonProducts");
    // Re-render the comparison section
    this.renderBar();
    // Hide the comparison open button
    this.toggleComparisonOpen();
    // Close the comparison modal if it's open
    this.closeComparison();
    this.closeComparisonModal();
    // Uncheck all comparison checkboxes on the page
    document.querySelectorAll(".comparison-checkbox").forEach((checkbox) => {
      checkbox.checked = false;
    });

    // if there, go to the last checkbox
    if (this._lastActiveCheckbox) {
      this._lastActiveCheckbox.focus();
      this._lastActiveCheckbox = null;
    }

    // console.log("Products after clearing:", this.products);
  }

  // Show/Hide open modal button if there are products in the comparison
  toggleComparisonOpen() {
    const comparisonOpenButton = document.querySelector(".comparison-open");

    if (this.products.length === 0) {
      comparisonOpenButton.classList.add("hidden");
    } else {
      comparisonOpenButton.removeAttribute("aria-hidden");
      comparisonOpenButton.classList.remove("hidden");
    }
  }

  // Sets everything up when landing on a new page
  initialiseProducts() {
    this.getProductsFromStorage();
    // Bind checkbox change event listeners after products are initialised
    document.querySelectorAll(".comparison-checkbox").forEach((checkbox) => {
      checkbox.addEventListener("change", this.handleCheckboxChange.bind(this));
    });
    this.renderBar();
    this.toggleComparisonOpen();
    this.removeSingleProduct();
    this.accessibilityUpdates();
    this.updateComparisonCount();
    // console.log("Initialised products:", this.products);
  }

  // Formatting for product descriptions
  stripHtmlAndTruncate(text, wordLimit) {
    if (!text || typeof text !== "string") return "";
    const plainText = text.replace(/<\/?[^>]+(>|$)/g, "");
    const words = plainText.split(/\s+/).slice(0, wordLimit);
    return words.join(" ") + (words.length === wordLimit ? "..." : "");
  }

  // Formatting for money with local currency
  formatMoney(amount, currency = window.Shopify.currency.active || "USD") {
    // Divide the amount by 100 to handle integer values
    const normalizedAmount = amount / 100;
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currency,
    }).format(normalizedAmount);
  }

  // Render the comparison bottom bar with selected products
  renderBar() {
    const comparisonSection = document.querySelector(
      "#comparison-product-list"
    );

    const removeIcon = `
    <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
      <path d="M11.7714 4.998C11.5111 4.73765 11.089 4.73765 10.8286 4.998L7.99995 7.82668L5.17176 4.99849C4.91141 4.73814 4.4893 4.73814 4.22895 4.99849C3.9686 5.25884 3.9686 5.68095 4.22895 5.9413L7.05714 8.76949L4.22897 11.5977C3.96862 11.858 3.96862 12.2801 4.22897 12.5405C4.48932 12.8008 4.91143 12.8008 5.17178 12.5405L7.99995 9.7123L10.8286 12.541C11.089 12.8013 11.5111 12.8013 11.7714 12.541C12.0318 12.2806 12.0318 11.8585 11.7714 11.5982L8.94276 8.76949L11.7714 5.94081C12.0318 5.68046 12.0318 5.25835 11.7714 4.998Z" fill="currentColor"/>
    </svg>
  `;

    // Get all the additional product info from a fetch, this can then be found by the modal too.
    // Metafields can only be grabbed from the local storage due to the product API not exposing them to us.
    Promise.all(
      this.products.map((product) => {
        const productHandle = product.url.split("/").pop().replace(".html", ""); // Extract handle from URL
        const productApiUrl = `${window.Shopify.routes.root}products/${productHandle}.js`;

        return fetch(productApiUrl)
          .then((response) => {
            if (!response.ok) {
              throw new Error(
                `Failed to fetch product data for ${productHandle}`
              );
            }
            return response.json();
          })
          .then((fetchedProduct) => {
            // Update product details with fetched data
            return {
              ...product,
              title: product.title || fetchedProduct.title,
              image: fetchedProduct.images[0],
              Compareprice: fetchedProduct.compare_at_price,
              price: fetchedProduct.price,
              description: fetchedProduct.description,
              tags: fetchedProduct.tags,
              created_at: fetchedProduct.created_at,
            };
          })
          .catch((error) => {
            // console.error("Error fetching product data:", error.message);
            return product; // Fallback to existing product data
          });
      })
    ).then((updatedProducts) => {
      // Update the products array with fetched data
      this.products = updatedProducts;

      // Render the updated products
      let productHTML = this.products
        .map(
          (product) => `
      <div class="comparison-product">
        <a href="${decodeURIComponent(product.url)}" aria-label="${
            window.productComparisonHeadings.view
          } ${decodeURIComponent(
            product.title
          )}" class="comparison-product-img-wrapper">
          <img src="${decodeURIComponent(
            product.image
          )}" alt="${decodeURIComponent(product.title)}">
        </a>
        <div class="comparison-product-info">
          <p class="comparison-product-title product-title-sm snug-text">${decodeURIComponent(
            product.title
          )}</p>
          <p class="price comparison-product-price card-price snug-text">${this.formatMoney(
            product.price
          )}</p>
        </div>
        <button class="comparison-product-remove" tab-index="0" aria-label="${
          window.productComparisonHeadings.remove
        } ${decodeURIComponent(
            product.title
          )} from comparison" data-product-id="${product.id}">
          ${removeIcon}
        </button>
      </div>
    `
        )
        .join("");

      // Add placeholder products if less than 3 products are added
      const placeholdersNeeded = 3 - this.products.length;
      for (let i = 0; i < placeholdersNeeded; i++) {
        productHTML += `
      <div class="comparison-product comparison-product-placeholder">
        <div class="comparison-product-info">
          <h4 class="body-md snug-text">${window.productComparisonHeadings.anotherBikeHeading}</h4>
        </div>
      </div>
    `;
      }

      // Update the comparison section with the generated HTML
      comparisonSection.innerHTML = productHTML;

      // Re-bind event listeners for remove buttons
      this.removeSingleProduct();
    });
  }

  // arrow controls function
  handleArrowButtonClick() {
    const comparisonControls = document.querySelectorAll(
      ".product-comparison-controls"
    );
    const summaryContainer = document.querySelector(
      ".product-comparison-modal-summary"
    );
    const productsContainer = document.querySelector(
      ".product-comparison-modal-products"
    );
    const toggleContentContainer = document.querySelector(
      ".product-comparison-modal-toggle-content"
    );
    const buttonContainer = document.querySelector(
      ".product-comparison-buttons"
    );

    if (
      comparisonControls.length > 0 &&
      productsContainer &&
      toggleContentContainer &&
      buttonContainer &&
      summaryContainer
    ) {
      comparisonControls.forEach((controls) => {
        controls.addEventListener("click", (event) => {
          const button = event.target.closest(".button-arrow");
          if (button) {
            const scrollAmount =
              productsContainer.firstElementChild.clientWidth; // Adjust for item width + gap
            // console.log("Scroll amount:", scrollAmount);
            if (button.classList.contains("button-arrow--prev")) {
              productsContainer.scrollBy({
                left: -scrollAmount,
                behavior: "smooth",
              });
              toggleContentContainer.scrollBy({
                left: -scrollAmount,
                behavior: "smooth",
              });
              buttonContainer.scrollBy({
                left: -scrollAmount,
                behavior: "smooth",
              });
            } else if (button.classList.contains("button-arrow--next")) {
              productsContainer.scrollBy({
                left: scrollAmount,
                behavior: "smooth",
              });
              toggleContentContainer.scrollBy({
                left: scrollAmount,
                behavior: "smooth",
              });
              buttonContainer.scrollBy({
                left: scrollAmount,
                behavior: "smooth",
              });
            }

            // Sync the state of all controls
            this.syncControlsState(comparisonControls, productsContainer);
          }
        });
      });

      const updateButtonVisibility = () => {
        this.syncControlsState(comparisonControls, productsContainer);
      };

      // Attach scroll and resize listeners
      productsContainer.addEventListener("scroll", updateButtonVisibility);
      window.addEventListener("resize", updateButtonVisibility);

      // Return the function so it can be called externally
      return updateButtonVisibility;
    }
  }

  // Keep all arrow controls in the same state since there is a top set & bottom set
  // ...existing code...
  syncControlsState(controls, container) {
    controls.forEach((control) => {
      const prevButton = control.querySelector(".button-arrow--prev");
      const nextButton = control.querySelector(".button-arrow--next");

      const isPrevDisabled = container.scrollLeft === 0;
      const isNextDisabled =
        container.scrollLeft + container.clientWidth >= container.scrollWidth;

      prevButton.classList.toggle("disabled", isPrevDisabled);
      nextButton.classList.toggle("disabled", isNextDisabled);

      if (isPrevDisabled) {
        prevButton.setAttribute("tabindex", "-1");
      } else {
        prevButton.removeAttribute("tabindex");
      }

      if (isNextDisabled) {
        nextButton.setAttribute("tabindex", "-1");
      } else {
        nextButton.removeAttribute("tabindex");
      }
    });
  }
  // ...existing code...

  // Keep all the scroll snaps aligned, so all content is in sync
  synchroniseScroll() {
    const summaryContainer = document.querySelector(
      ".product-comparison-modal-summary-wrapper"
    );
    const productsContainer = document.querySelector(
      ".product-comparison-modal-products"
    );
    const toggleContentContainer = document.querySelector(
      ".product-comparison-modal-toggle-content"
    );
    const buttonContainer = document.querySelector(
      ".product-comparison-buttons"
    );

    if (productsContainer && toggleContentContainer && buttonContainer) {
      const containers = [
        summaryContainer,
        productsContainer,
        toggleContentContainer,
        buttonContainer,
      ];
      let isProgrammaticScroll = false; // Flag to differentiate programmatic scrolls

      containers.forEach((container) => {
        container.addEventListener("scroll", (event) => {
          if (isProgrammaticScroll) return; // Ignore programmatic scrolls

          const { scrollLeft } = event.target;

          // Temporarily disable listeners to prevent loops
          isProgrammaticScroll = true;

          // Synchronize the scroll position of all other containers with smooth scrolling
          containers.forEach((otherContainer) => {
            if (otherContainer !== event.target) {
              otherContainer.scrollTo({
                left: scrollLeft,
                behavior: "smooth", // Smooth scrolling
              });
            }
          });

          // Re-enable listeners after the scroll update
          setTimeout(() => {
            isProgrammaticScroll = false;
          }, 300); // Delay to match the smooth scroll duration
        });

        //  This makes sure if an element is focused on, it stays in view
        container.addEventListener("focusin", (event) => {
          const focusedElement = event.target;
          if (container.contains(focusedElement)) {
            focusedElement.scrollIntoView({
              behavior: "smooth",
              block: "nearest",
              inline: "nearest",
            });
          }
        });
      });
    }
  }

  // Updates the label for the comparison list
  accessibilityUpdates() {
    setTimeout(() => {
      const accessibilityList = document.querySelector("#products-compared");
      const productTitles = this.products
        .map((product) => product.title)
        .join(", ");
      if (accessibilityList) {
        // console.log("accessibilityList", accessibilityList);
        accessibilityList.textContent = `Comparing products: ${productTitles}`;
      }
    }, 100);
  }

  // Wipe all products from tool and storage
  clearAllProducts(productData) {
    // console.log("Clearing ", productData);
    // Clear the products array
    productData.forEach((product) => {
      // console.log("Removing product:", product);
      this.removeProduct(product.id);
    });
    // Clear localStorage
    localStorage.removeItem("comparisonProducts");

    // Re-render the comparison section
    this.renderBar();

    // Hide the comparison open button
    this.toggleComparisonOpen();

    // Close the comparison modal if it's open
    this.closeComparison();
    this.closeComparisonModal();

    // Uncheck all comparison checkboxes on the page
    document.querySelectorAll(".comparison-checkbox").forEach((checkbox) => {
      checkbox.checked = false;
    });

    // console.log("Products after clearing:", this.products);
  }

  // Update the total product counter
  updateComparisonCount() {
    const comparisonCountElements =
      document.querySelectorAll(".comparison-count");
    comparisonCountElements.forEach((element) => {
      element.textContent = this.products.length;
    });
  }

  // The larger information modal, triggered by the "Compare All" button
  renderComparisonModal() {
    // console.log("Rendering comparison modal with ", this.products);
    const modal = document.querySelector(".product-comparison-modal");

    const summaryContent = modal.querySelector(
      ".product-comparison-modal-summary"
    );
    const modalContent = modal.querySelector(
      ".product-comparison-modal-products"
    );
    const toggleContent = modal.querySelector(
      ".product-comparison-modal-toggle-content"
    );
    const buttonContent = modal.querySelector(".product-comparison-buttons");

    // Fallback
    if (this.products.length === 0) {
      this.getProductsFromStorage();
    }

    // Get the global array of translated headings
    const highlightHeadings = window.productComparisonHeadings;
    const arrowIcon = `
    <svg aria-hidden="true" class="icon icon-button-arrow" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="4.67 3.33 6.66 9.33">
      <g id="Trailing Icon"><path id="tree" d="M4.66968 12.6666V3.33325L11.3303 8.00202L4.66968 12.6666Z" fill="currentColor"></path></g>
    </svg>`;

    const removeIcon = `
        <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
          <path d="M11.7714 4.998C11.5111 4.73765 11.089 4.73765 10.8286 4.998L7.99995 7.82668L5.17176 4.99849C4.91141 4.73814 4.4893 4.73814 4.22895 4.99849C3.9686 5.25884 3.9686 5.68095 4.22895 5.9413L7.05714 8.76949L4.22897 11.5977C3.96862 11.858 3.96862 12.2801 4.22897 12.5405C4.48932 12.8008 4.91143 12.8008 5.17178 12.5405L7.99995 9.7123L10.8286 12.541C11.089 12.8013 11.5111 12.8013 11.7714 12.541C12.0318 12.2806 12.0318 11.8585 11.7714 11.5982L8.94276 8.76949L11.7714 5.94081C12.0318 5.68046 12.0318 5.25835 11.7714 4.998Z" fill="currentColor"/>
        </svg>
      `;

    // Clear existing content
    summaryContent.innerHTML = "";
    modalContent.innerHTML = "";
    toggleContent.innerHTML = "";
    buttonContent.innerHTML = "";

    // All the specifications currently being used in the selection.
    // This means every product can have the heading, but not neccessarily the content to make sure it all aligns nicely
    const allKeys = new Set();
    this.products.forEach((product) => {
      try {
        Object.keys(product.specifications).forEach((key) => allKeys.add(key));
      } catch (e) {}
    });
    const allKeysArray = Array.from(allKeys);

    // Populate modal with product data
    this.products.forEach((product) => {
      const isNewProduct =
        product.created_at &&
        new Date(product.created_at) >
          new Date(Date.now() - 30 * 24 * 60 * 60 * 1000); // Check if product is created within the last 30 days
      const isOnSale = product.Compareprice > 0;

      summaryContent.innerHTML += `
      <div class="comparison-modal-product-summary-item">
        <a aria-hidden="true" tabindex="-1" href="${decodeURIComponent(
          product.url
        )}" aria-label="${
        window.productComparisonHeadings.view
      } ${decodeURIComponent(
        product.title
      )}" class="comparison-product-img-wrapper">
          <img src="${decodeURIComponent(
            product.image
          )}" alt="${decodeURIComponent(product.title)}">
        </a>
        <div class="comparison-product-info">
          <p class="comparison-product-title product-title-sm snug-text">${decodeURIComponent(
            product.title
          )}</p>
          <p class="price comparison-product-price card-price snug-text">${this.formatMoney(
            product.price
          )}</p>
        </div>
        <button class="comparison-product-remove" tabindex="-1" aria-label="${
          window.productComparisonHeadings.remove
        } ${decodeURIComponent(
        product.title
      )} from comparison" data-product-id="${product.id}">
          ${removeIcon}
        </button>
      </div>
       `;

      modalContent.innerHTML += `
      <article class="comparison-modal-product" aria-labelledby="${
        product.id
      }-title">
        <div class="comparison-modal-product-image">
          <img src="${product.image}" alt="${product.title}">
        </div>

        <div class="comparison-modal-product-info">
        <div class="comparison-modal-product-header">
            <button class="comparison-product-remove button button-size-md button-style-minimal" aria-label="${
              window.productComparisonHeadings.remove
            } ${decodeURIComponent(
        product.title
      )} from comparison" data-product-id="${product.id}" tabindex="0">
             ${window.productComparisonHeadings.remove}
            </button>        
            <div class="comparison-modal-product-title">
            <h3 class="title-lg snug-heading" id="${product.id}-title">${
        product.title
      }</h3>
            <div class="comparison-modal-product-tags tags">
              ${
                isNewProduct
                  ? '<div class="tag tag-size-small no-hover new">New</div>'
                  : ""
              }
              ${
                isOnSale
                  ? '<div class="tag tag-size-small no-hover sale">Sale</div>'
                  : ""
              }            
            </div>
            </div>
            <p class="snug-text body-md">
              ${this.stripHtmlAndTruncate(product.description, 25)}
            </p>
            <div class="comparison-modal-product-footer">
            <div class="comparison-modal-product-footer-wrapper">
                <span class="price">
                <p class="price-item price-item--current card-price"> ${this.formatMoney(
                  product.price
                )}</p>
              ${
                product.Compareprice > 0
                  ? `<p class="price-item price-item--old card-price"> 
                      ${this.formatMoney(product.Compareprice)}
                    </p>`
                  : ""
              }
                </span>
                <a href="${decodeURIComponent(
                  product.url
                )}" class="button button-size-md button-style-primary">${
        window.productComparisonHeadings.view
      } ${decodeURIComponent(product.title)} ${arrowIcon}</a>
              </div>
            </div>
          </div>
           <!--
          <div class="comparison-product-highlights">
            <div class="swatches highlight-feature">   
            <h4 class="subtitle-lg snug-heading">${
              highlightHeadings.colorHeading
            }
            </h4>         
            ${`<div class="swatches">
              ${
                product.swatches
                  ? Object.entries(product.swatches)
                      .map(
                        ([key, swatch]) => `
                          <div class="swatch-item">
                            ${
                              swatch.swatch_img
                                ? `<img src="${decodeURIComponent(
                                    swatch.swatch_img
                                  )}" alt="${
                                    swatch.color_name
                                  }" class="swatch-image swatch-img img" />`
                                : `<div class="swatch-img swatch-colors">
                                    ${
                                      swatch.first_swatch
                                        ? `<span class="swatch-half" style="background-color: ${swatch.first_swatch}"></span>`
                                        : ""
                                    }
                                    ${
                                      swatch.second_swatch
                                        ? `<span class="swatch-half" style="background-color: ${swatch.second_swatch}"></span>`
                                        : ""
                                    }
                                  </div>`
                            }
                          </div>
                        `
                      )
                      .join("")
                  : `<p class="no-swatches-message">No swatches available</p>`
              }
            </div>`}
            </div>
            <div class="gender highlight-feature">
            <h4 class="subtitle-lg snug-heading">${
              highlightHeadings.genderHeading
            }</h4>
            <p class="gender snug-text body-md">${product.gender || ""}</p>
            </div>     
            <div class="season highlight-feature">
            <h4 class="subtitle-lg snug-heading">${
              highlightHeadings.seasonHeading
            }</h4>
            <p class="snug-text body-md">${product.season || ""}</p>
            </div>
          </div>
          -->
        </div>
      </article>
    `;

      //   // Specifications toggle content
      //   let specificationsHTML = "";
      //   allKeysArray.forEach((key) => {
      //     const value = product.specifications[key] || "";
      //     // Turn key into title by replacing underscores with spacing and capitalising words
      //     const formattedKey = key
      //       .replace("product_specifications", "")
      //       .replace(/_/g, " ")
      //       .replace(/\b\w/g, (char) => char.toUpperCase())
      //       .trimStart();

      //     specificationsHTML += `
      //       <div class="specification-item">
      //         <h5 class="toggle-subheading snug-text">${formattedKey}</h5>
      //         <p class="body-sm snug-text">${value || " "}</p>
      //       </div>
      //     `;
      //   });

      //   toggleContent.innerHTML += `
      //   <div class="comparison-modal-product-specifications">
      //     <h3 class="product-specifications-title visually-hidden">${product.title}</h3>
      //     ${specificationsHTML}
      //   </div>
      // `;
      // Specifications table content

      let colCount = this.products.length;
      let colgroup = "<colgroup>";
      for (let i = 0; i < colCount; i++) {
        colgroup += `<col style="min-width:350px;width:calc(max(33% - var(--global-col-gap-md) * 1.75, min(350px, 100%)));">`;
      }
      colgroup += "</colgroup>";

      let specificationsTableHTML = `
        <table class="comparison-modal-specifications-table">
          ${colgroup}
          <thead class="visually-hidden">
            <tr>
              ${this.products
                .map(
                  (product) => `
                    <th class="comparison-table-product-heading">
                      <span class="visually-hidden">Product:</span>
                      ${product.title}
                    </th>
                  `
                )
                .join("")}
            </tr>
          </thead>          
          <tbody>
            ${allKeysArray
              .map((key) => {
                const formattedKey = key
                  .replace("product_specifications", "")
                  .replace(/_/g, " ")
                  .replace(/\b\w/g, (char) => char.toUpperCase())
                  .trimStart();
                const headingIds = this.products.map(
                  (_, idx) => `spec-${key}-${idx}`
                );
                return `
                  <tr>
                    ${this.products
                      .map(
                        (_, idx) =>
                          `<th id="${headingIds[idx]}" class="toggle-subheading snug-text" scope="col">${formattedKey}</th>`
                      )
                      .join("")}
                  </tr>
                  <tr>
                    ${this.products
                      .map((product, idx) => {
                        const value = product.specifications[key] || "";
                        return `<td class="body-sm snug-text" aria-describedby="${
                          headingIds[idx]
                        }">${value || "&nbsp;"}</td>`;
                      })
                      .join("")}
                  </tr>
                `;
              })
              .join("")}
          </tbody>
        </table>
      `;
      toggleContent.innerHTML = specificationsTableHTML;

      // Populate buttonContent with a link to each product
      buttonContent.innerHTML = this.products
        .map(
          (product) => `
      <a href="${decodeURIComponent(product.url)}" 
         class="button button-size-md button-style-primary" 
         aria-label="${
           window.productComparisonHeadings.view
         } ${decodeURIComponent(product.title)}">
        ${window.productComparisonHeadings.view} ${decodeURIComponent(
            product.title
          )} ${arrowIcon}
      </a>
    `
        )
        .join("");
    });
    // Show the modal
    modal.style.display = "block";
    // Disable body scrolling
    document.body.style.overflow = "hidden";
    document.querySelector("gaia-header").style.zIndex = "10";

    // Show the summary header when the product details have been scrolled past
    const productHeaders = modal.querySelectorAll(
      ".comparison-modal-product-header"
    );
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            summaryContent.classList.add(
              "product-comparison-modal-summary-visible"
            );
          } else {
            summaryContent.classList.remove(
              "product-comparison-modal-summary-visible"
            );
          }
        });
      },
      { root: modal, threshold: 0 }
    );

    productHeaders.forEach((header) => observer.observe(header));

    // Remove any existing focus trap
    this.removeFocus();
    this.removeBarFocusTrap();
    const focusFirstElement = document.querySelector(
      ".product-comparison-modal-close"
    );
    const focusSecondElement = document.querySelector(
      ".comparison-modal-product-header .comparison-product-remove"
    );
    const focusLastElement = document.querySelector(
      ".product-comparison-controls-bottom .button-arrow--next"
    );
    // Modal set focus
    this.setFocus(focusFirstElement, focusSecondElement, focusLastElement);

    // Reinitialise this for remove buttons
    this.removeSingleProduct();
    // Update button visibility
    const updateButtonVisibility = this.handleArrowButtonClick();
    if (updateButtonVisibility) {
      updateButtonVisibility(); // Call immediately to set the correct state
    }
  }

  // Close larger comparison modal
  closeComparisonModal() {
    const modal = document.querySelector(".product-comparison-modal");
    modal.style.display = "none";
    document.body.style.overflow = "";
    document.querySelector("gaia-header").style.zIndex = "1000000";
    // this.toggleComparison();
    var nextFocusElement = document.querySelector(".comparison-toggle-button");
    this.closeComparison();
    this.removeFocus();
    this.removeBarFocusTrap();
    if (this._lastActiveCheckbox) {
      this._lastActiveCheckbox.focus();
    } else {
      // fallback to toggle button if no checkbox
      const nextFocusElement = document.querySelector(
        ".comparison-toggle-button"
      );
      if (nextFocusElement) nextFocusElement.focus();
    }
  }

  // Set trap focus within the elements
  setFocus(firstElement, secondElement, lastElement) {
    console.log("setFocus called with:", {
      firstElement,
      secondElement,
      lastElement,
    });
    if (this._trapFocus) {
      document.removeEventListener("keydown", this._trapFocus);
      this._trapFocus = null;
      console.log("Existing focus trap removed.");
    }

    const trapFocus = (event) => {
      console.log("Keydown event:", event.key);
      if (event.key !== "Tab") return;

      const active = document.activeElement;

      // Shift+Tab from firstElement loops to lastElement
      if (event.shiftKey && active === firstElement) {
        event.preventDefault();
        lastElement.focus();
        console.log("Focus moved to lastElement.");
      }
      // Tab from firstElement goes to secondElement (if provided)
      else if (!event.shiftKey && active === firstElement && secondElement) {
        event.preventDefault();
        secondElement.focus();
        console.log("Focus moved to secondElement.");
      }
      // Tab from lastElement loops to firstElement
      else if (!event.shiftKey && active === lastElement) {
        event.preventDefault();
        firstElement.focus();
        console.log("Focus moved to firstElement.");
      }
      // Shift+Tab from lastElement goes to secondElement (if provided)
      else if (event.shiftKey && active === lastElement && secondElement) {
        event.preventDefault();
        secondElement.focus();
        console.log("Focus moved to secondElement.");
      }
      // Otherwise, let browser handle focus naturally
    };

    document.addEventListener("keydown", trapFocus);
    this._trapFocus = trapFocus;

    if (firstElement) firstElement.focus();
    console.log("Focus trap set.");
  }
  // Remove a trap focus
  removeFocus(nextFocusElement) {
    if (this._trapFocus) {
      document.removeEventListener("keydown", this._trapFocus);
      this._trapFocus = null;
    } else {
    }
    // If a nextFocusElement is provided, move focus to it
    if (nextFocusElement) {
      nextFocusElement.focus();
    }
  }

  getFocusableElements(container) {
    return Array.from(
      container.querySelectorAll(
        'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
      )
    ).filter(
      (el) => !el.hasAttribute("disabled") && !el.getAttribute("aria-hidden")
    );
  }

  // This is specifically for the mini comparison bar, since it has a specific focus order we want to maintain
  trapFocusInBar() {
    const bar = document.querySelector("product-comparison:not([hidden])");
    if (!bar) return;

    const getCurrentFocusableEls = () => {
      let els = this.getFocusableElements(bar).filter(
        (el) =>
          el.offsetParent !== null &&
          !el.hasAttribute("aria-hidden") &&
          el.tabIndex !== -1 &&
          !el.disabled
      );
      const toggleButton = document.querySelector(".comparison-toggle-button");
      if (
        toggleButton &&
        toggleButton.offsetParent !== null &&
        !toggleButton.hasAttribute("aria-hidden") &&
        toggleButton.tabIndex !== -1 &&
        !toggleButton.disabled
      ) {
        els = [toggleButton, ...els];
      }
      return els;
    };

    // Always get the latest focusable elements before focusing
    let focusableEls = getCurrentFocusableEls();
    if (focusableEls.length <= 1) return;
    focusableEls[1].focus();

    if (this._barTrapFocus) {
      document.removeEventListener("keydown", this._barTrapFocus);
      this._barTrapFocus = null;
    }

    this._barTrapFocus = (event) => {
      if (this._isClosingBar) {
        return;
      }
      if (event.key !== "Tab") return;

      // Get the latest focusable elements every time
      const focusableEls = getCurrentFocusableEls();
      const activeElement = document.activeElement;
      const focusIndex = focusableEls.indexOf(activeElement);

      // If not in our list, forcibly redirect to first or last
      if (focusIndex === -1) {
        event.preventDefault();
        if (event.shiftKey) {
          focusableEls[focusableEls.length - 1].focus();
        } else {
          focusableEls[0].focus();
        }
        return;
      }

      if (!event.shiftKey) {
        // Tab forward: if at last, loop to toggle button (first in array)
        if (focusIndex === focusableEls.length - 1) {
          event.preventDefault();
          focusableEls[0].focus();
        }
      } else {
        // Shift+Tab backward: if at toggle button, loop to last bar element
        if (focusIndex === 0) {
          event.preventDefault();
          focusableEls[focusableEls.length - 1].focus();
        }
      }
    };

    this._barFocusInHandler = (event) => {
      const bar = document.querySelector("product-comparison");
      if (!bar || bar.hasAttribute("hidden") || this._isClosingBar) {
        return;
      }
      const focusableEls = getCurrentFocusableEls();

      if (!focusableEls.includes(event.target)) {
        event.stopPropagation();

        focusableEls[1] ? focusableEls[1].focus() : focusableEls[0].focus();
      }
    };
    document.addEventListener("focusin", this._barFocusInHandler);

    document.addEventListener("keydown", this._barTrapFocus);
  }
  // Remove the bar focus trap
  removeBarFocusTrap() {
    if (this._barTrapFocus) {
      document.removeEventListener("keydown", this._barTrapFocus);
      this._barTrapFocus = null;
    }
    if (this._barFocusInHandler) {
      document.removeEventListener("focusin", this._barFocusInHandler);
      this._barFocusInHandler = null;
    }
  }
}
customElements.define("product-comparison", ProductComparison);

document.addEventListener("DOMContentLoaded", () => {
  const productComparison = new ProductComparison();

  // Close modal
  const modalCloseButton = document.querySelector(
    ".product-comparison-modal-close"
  );
  if (modalCloseButton) {
    modalCloseButton.addEventListener("click", () => {
      productComparison.closeComparisonModal();
    });
    modalCloseButton.addEventListener("keydown", (event) => {
      if (event.key === "Enter" || event.keyCode === 13) {
        productComparison.closeComparisonModal();
      }
    });
  }
});
